import React, { useState } from "react";
import { PhotoshopPicker } from "react-color";
import "./createProject.scss";
import Alert from "@mui/material/Alert";
import { createProject } from "../../api/project";
import { useRequest } from "ahooks";

export default function CreateProject({ data }) {
  const [name, setName] = useState("");
  const [width, setWidth] = useState(900);
  const [height, setHeight] = useState(300);
  const [unit] = useState("px");
  const [background, setBackground] = useState("#fff");
  const [showColor, setShowColor] = useState(false);
  const [showColorCard, setShowColorCard] = useState(false);
  const [preColor, setPreColor] = useState("#000");
  const [showAlert, setShowAlert] = useState(false);
  const canvasStyle = {
    unit: "px",
    width: width,
    height: height,
    backgroundColor: background,
    name,
  };

    const { runAsync: createProjectRequest } = useRequest(createProject, {
      manual: true,
      onSuccess: (res) => {
        if (res.code === 200) {
          console.log("Project created successfully:", res.data);
          setName(res.data.name);
          localStorage.setItem("projectId", res.data.id);
      data(res.data.name, canvasStyle);
        }
      },
      onError: (err) => {
        console.error("Error creating project:", err);
      },
    });

  const handleChangeComplete = (color) => {
    setBackground(color.hex);
  };
  const acceptColor = () => {
    setPreColor(background);
    setShowColor(false);
    setShowColorCard(true);
  };
  const cancelColor = () => {
    setBackground(preColor);
    setShowColor(false);
    setShowColorCard(true);
  };
  const handleCreate = () => {
    if (name && width && height) {
      if (unit === "%") {
        let screenWidth = window.screen.width - 480;
        let screenHeight = window.screen.height - 90;
        canvasStyle.width = (screenWidth * width) / 100;
        canvasStyle.height = (screenHeight * height) / 100;
      }
      createProjectRequest({
        name,
        bgColor: background,
        designStandard: "default",
      });
    } else {
      setShowAlert(true);
    }
  };
  const closeCreate = () => {
    setName("");
    setWidth("");
    setHeight("");
    setBackground("#fff");
    setShowColorCard(false);
    setShowColor(false);
    data();
  };

  return (
    <div>
      {showAlert && (
        <Alert severity="error" onClose={() => setShowAlert(false)}>
          请提供完整信息
        </Alert>
      )}
      <div className="card">
        <div className="top">
          <div className="cardTitle">
            <p>新建项目</p>
          </div>
          {/* <div className="delete" onClick={closeCreate}>
                        <p>X</p>
                    </div> */}
        </div>
        <div className="cardBody">
          <div className="cardItem">
            <p>项目名称：</p>
            <input
              type="text"
              value={name}
              placeholder="请输入项目名称"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          {/* <div className="cardItem">
                        <p>宽度：</p>
                        <input type="number" value={width} onChange={(e) => setWidth(e.target.value)} />
                        <select onChange={(e) => setUnit(e.target.value)}>
                            <option value="px">像素</option>
                            <option value="%">百分比</option>
                        </select>
                    </div>
                    <div className="cardItem">
                        <p>高度：</p>
                        <input type="number" value={height} onChange={(e) => setHeight(e.target.value)} />
                        <div style={{ width: 100 + 'px', height: 30 + 'px', background: '#252525', marginLeft: 10 + 'px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {unit === 'px' ? '像素' : '百分比'}
                        </div>
                    </div> */}
          <div className="cardItem">
            <p>背景颜色：</p>
            <select onChange={(e) => setBackground(e.target.value)}>
              <option value="#fff">white</option>
              <option value="#333">black</option>
              <option value="自定义">custom</option>
            </select>
            {(background === "自定义" ||
              (showColorCard &&
                background !== "#333" &&
                background !== "#fff")) && (
              <div
                className="colorCard"
                onClick={() => setShowColor(true)}
                style={{ backgroundColor: background }}
              ></div>
            )}
            {showColor && (
              <PhotoshopPicker
                header="colorPicker"
                onChangeComplete={handleChangeComplete}
                color={background}
                className="colorPicker"
                onAccept={acceptColor}
                onCancel={cancelColor}
              />
            )}
          </div>
        </div>
        <div className="createBtns">
          <div className="cardBtn" onClick={closeCreate}>
            <p>返回</p>
          </div>
          <div className="cardBtn create" onClick={handleCreate}>
            <p>创建</p>
          </div>
        </div>
        <p style={{ color: "#fff", fontSize: 12, textAlign: "center", marginTop: 10 }}>
        该平台使用“智翎云境”作为网页端运行引擎
        </p>
      </div>
    </div>
  );
}
